// Centralized tag/department color configuration
// Based on the reference image colors

export const TAG_COLORS: Record<string, { bg: string; text: string; border: string }> = {
  TECH: {
    bg: 'bg-orange-100',
    text: 'text-orange-800',
    border: 'border-orange-300'
  },
  MKT: {
    bg: 'bg-pink-100',
    text: 'text-pink-800',
    border: 'border-pink-300'
  },
  CREA: {
    bg: 'bg-cyan-100',
    text: 'text-cyan-800',
    border: 'border-cyan-300'
  },
  BIZ: {
    bg: 'bg-gray-100',
    text: 'text-gray-800',
    border: 'border-gray-300'
  },
  CONSLT: {
    bg: 'bg-purple-100',
    text: 'text-purple-800',
    border: 'border-purple-300'
  },
  LEGAL: {
    bg: 'bg-blue-100',
    text: 'text-blue-800',
    border: 'border-blue-300'
  },
  KAIZEN: {
    bg: 'bg-rose-100',
    text: 'text-rose-800',
    border: 'border-rose-300'
  },
  EDU: {
    bg: 'bg-green-100',
    text: 'text-green-800',
    border: 'border-green-300'
  },
  // Fallback for unknown tags
  DEFAULT: {
    bg: 'bg-slate-100',
    text: 'text-slate-800',
    border: 'border-slate-300'
  }
};

// Helper function to get tag color classes
export function getTagColorClasses(tag: string): string {
  const colors = TAG_COLORS[tag] || TAG_COLORS.DEFAULT;
  return `${colors.bg} ${colors.text} ${colors.border}`;
}

// Helper function to get individual color properties
export function getTagColors(tag: string): { bg: string; text: string; border: string; borderColorValue: string } {
  const colors = TAG_COLORS[tag] || TAG_COLORS.DEFAULT;
  
  // Map border classes to actual color values for inline styles
  const borderColorMap: Record<string, string> = {
    'border-orange-300': '#fdba74',
    'border-pink-300': '#f9a8d4',
    'border-cyan-300': '#67e8f9',
    'border-gray-300': '#d1d5db',
    'border-purple-300': '#d8b4fe',
    'border-blue-300': '#93c5fd',
    'border-rose-300': '#fda4af',
    'border-green-300': '#86efac',
    'border-slate-300': '#cbd5e1'
  };
  
  return {
    ...colors,
    borderColorValue: borderColorMap[colors.border] || '#cbd5e1'
  };
}

// Hex colors for charts - matching the department/tag colors
export const TAG_CHART_COLORS: Record<string, string> = {
  TECH: '#f97316',    // orange-500
  MKT: '#ec4899',     // pink-500
  CREA: '#06b6d4',    // cyan-500
  BIZ: '#6b7280',     // gray-500
  CONSLT: '#a855f7',  // purple-500
  LEGAL: '#3b82f6',   // blue-500
  KAIZEN: '#f43f5e',  // rose-500
  EDU: '#22c55e',     // green-500
  DEFAULT: '#64748b', // slate-500
};

// Get chart color for a department/tag
export function getTagChartColor(tag: string): string {
  return TAG_CHART_COLORS[tag] || TAG_CHART_COLORS.DEFAULT;
}

// Get all available tags
export function getAllTags(): string[] {
  return Object.keys(TAG_COLORS).filter(key => key !== 'DEFAULT');
}
